module.exports = __webpack_public_path__ + "b2e0fc821c6886fb3940f85a3320003e.ttf";